export const BlogCreationErrorTypes = Object.freeze({
  BLOG_DOMAINS_ENTERPRISE_ONLY: 'BLOG_DOMAINS_ENTERPRISE_ONLY',
  BLOG_NAME_EXISTS: 'BLOG_NAME_EXISTS',
  BLOG_NAME_MISSING: 'BLOG_NAME_MISSING',
  BLOG_NAME_NO_HTML: 'BLOG_NAME_NO_HTML',
  BLOG_NAME_TOO_LONG: 'BLOG_NAME_TOO_LONG',
  BLOG_SLUG_TOO_LONG: 'BLOG_SLUG_TOO_LONG',
  BLOG_URL_EXISTS: 'BLOG_URL_EXISTS',
  REDIRECT_EXISTS: 'REDIRECT_EXISTS',
  SLUG_EXISTS: 'SLUG_EXISTS',
  PAGE_EXISTS: 'PAGE_EXISTS'
});